"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ConsoleAnalytics = _interopRequireDefault(require("./ConsoleAnalytics"));

var _GtmAnalytics = _interopRequireDefault(require("./GtmAnalytics"));

var _StorybookAnalytics = _interopRequireDefault(require("./StorybookAnalytics"));

var _NullAnalytics = _interopRequireDefault(require("./NullAnalytics"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var getAnalytics = function getAnalytics(engineName) {
  var engine = null;

  for (var _len = arguments.length, extra = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    extra[_key - 1] = arguments[_key];
  }

  switch (engineName) {
    case "storybook":
      engine = _construct(_StorybookAnalytics["default"], extra);
      break;

    case "gtm":
      engine = _construct(_GtmAnalytics["default"], extra);
      break;

    case "console":
      engine = _construct(_ConsoleAnalytics["default"], extra);
      break;

    case "null":
      engine = _construct(_NullAnalytics["default"], extra);
      break;

    default:
      throw new Error("Unsupported analytics engine type: ".concat(engineName));
  } // Enforcing an interface of sorts.


  return function (category, action, label) {
    engine.sendEvent(category, action, label);
  };
};

var _default = getAnalytics;
exports["default"] = _default;